module.exports = __webpack_public_path__ + "img/ht.f49382a4.svg";